export function extractReviewBatches(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.batches)) {
    return payload.batches;
  }

  return [];
}
